import { fromJson } from "@bufbuild/protobuf";

import * as localStorage from "@uic/adapters/local-storage";
import { GetUserOrganizationsResponseSchema } from "@uic/adapters/slorgproto/wsc_pb";
import { wsc } from "@uic/domain/wsc";

const STORAGE_KEY = "selected-org-member-id";

/**
 * @typedef {import('@uic/adapters/slorgproto').OrganizationSchema} Org
 */

/**
 * Fetches user's organizations from WSC
 * @returns {Promise<Array<{membershipId: string, organization: Org}>>} The list of organizations
 */
export async function fetchUserOrganizations() {
  const response = await wsc.get("/organizations/");
  const protoResponse = fromJson(
    GetUserOrganizationsResponseSchema,
    response.data,
  );
  return protoResponse.memberships || [];
}

/**
 * Gets the saved org member ID from local storage
 * @returns {string|null} The org member id
 */
export function getSavedOrgMemberId() {
  return localStorage.get(STORAGE_KEY);
}

/**
 * Saves the selected org member ID to local storage
 * @param {string} orgMemberId The orgmember
 */
export function saveOrgMemberId(orgMemberId) {
  localStorage.set(STORAGE_KEY, orgMemberId);
}

/**
 * Clears the saved org member ID
 */
export function clearOrgMemberId() {
  localStorage.remove(STORAGE_KEY);
}
